import React from 'react';

import language from '../../../assets/languages/language';
import { SecondsToHHMMSS } from '../../../common/constant';

function CBTTestTimeTaken(props) {
  let {
    userStatsData,
    params: { timer },
    userTime,
  } = props;

  if (userStatsData && userTime && timer) {
    userTime = SecondsToHHMMSS(
      userStatsData.isNegative === 'true' ? parseInt(timer, 10) + userTime : timer - userTime,
    );
  }

  return (
    <div className='timer_outer finished-time'>
      <div>
        <h4>{language.LC().TEST_COMPLETED_IN}</h4>
        <i className='fa fa-clock-o' />
        <span className='timer_box'>{userTime}</span>
      </div>
    </div>
  );
}

export default CBTTestTimeTaken;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/CBTTestTimeTaken.jsx